import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { updateTags } from "../utils/funcs";

export const HSForm = ({id}) => {

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: "536350",
                    formId: id,
                    target: "#HSForm",
                });
            }
        });
    }, []);

    return (
        <div style={{ padding: '2em', width: '90%', margin: '6em auto 2em auto', maxWidth: '800px', border: '1px solid black', borderRadius: '10px' }}>
            <div
                id="HSForm"
            />
        </div>
    )
}
